import SizeUtility from '../../../js/Utilities/SizeUtility';

class AccordionItem extends HTMLElement {
  details = {};
  desktopOverride = false;
  isDesktop = false;

  constructor() {
    super();

    this.details = this.querySelector('details');
    this.desktopOverride = this.hasAttribute('data-desktop');

    this._onWindowResize = this.onWindowResize.bind(this);
  }

  connectedCallback() {
    this.onWindowResize();

    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    window.addEventListener('resize', this._onWindowResize);
  }

  removeEventListeners() {
    window.removeEventListener('resize', this._onWindowResize);
  }

  onWindowResize() {
    if (this.desktopOverride && SizeUtility.isScreenGtLg() && !this.isDesktop) {
      this.details.open = true;
    }

    this.isDesktop = SizeUtility.isScreenGtLg();
  }
}

customElements.define('accordion-item', AccordionItem);
